import React from 'react';
import { mockServices } from '../data/mockData';
import '../styles/ServicesSection.css';

const ServicesSection = () => {
  return (
    <section id="services" className="services-section">
      <div className="services-container">
        <h2 className="section-title">OUR SERVICES</h2>
        
        <div className="services-grid">
          {mockServices.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon-wrapper">
                <div className="service-icon" style={{ backgroundColor: service.iconBg }}>
                  {service.icon}
                </div>
              </div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;